<div class="container-cookies d-grid justify-content-center" *ngIf="!cookiesAccepted">
    <i class="fa-light fa-cookie-bite icon-primary fa-2x"></i>
    <p class="title-cookies"> Política de Cookies</p>
    <p>Utilizamos cookies propias y de terceros para analizar nuestros servicios y mostrarte publicidad relacionada con
        tus preferencias, en base a un perfil elaborado a partir de tus hábitos de navegación (por ejemplo, páginas
        visitadas). Si continúas navegando, consideramos que aceptas su uso. Más información en nuestra
        <span class="link-policy" routerLink="/cookies">Política de cookies</span>
    </p>
    <button class="btn-cookies" (click)="saveCookies()">Aceptar cookies</button>
</div>